var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('section',{staticClass:"mb-3"},[_c('b-row',[_c('b-col',[_c('h2',[_vm._v(_vm._s(_vm.item.attributes.libelle))])])],1),_c('b-row',_vm._l((_vm.items),function(item){return _c('b-col',{key:item.id,attrs:{"cols":"auto"}},[_c('StrapiContactComponent',{attrs:{"item":item}})],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }